export default __webpack_public_path__ + "static/img/vogue_scene_animated_0079.8899298.webp";